import React, { useContext } from "react";
import { useMessageSource } from "react-message-source";
import { BootstrapperContext } from "../../../../context/bootstrapperContext";
import { DEFAULT_COUNTRY, PREFERRED_COUNTRIES } from "../../types";
import DropdownField from "../formik/dropdown";
import { Country as CountryType } from "../../../../api/commercial/generated-types";
import { DropdownFieldPropsType } from "../formik/dropdown/types.tsx";

export interface CountryPropsType {
  dataPath?: string;
  value: CountryType;
  asNationality?: boolean;
  forCompany?: boolean;
  onSelectCallback?: DropdownFieldPropsType["onSelectCallback"];
}

export default function Country({
  dataPath = "",
  value,
  asNationality = false,
  forCompany = false,
  onSelectCallback,
}: CountryPropsType): React.JSX.Element {
  const { getMessage } = useMessageSource();
  const { countries } = useContext(BootstrapperContext);
  const name = asNationality ? "nationality" : "country";
  const path = asNationality ? "nationality" : "address.country.alpha2";

  const sorted = countries
    ? [...countries].sort((a, b) => a.name.localeCompare(b.name))
    : [];
  const isoCodes = sorted.map((country) => country.isoCode);

  isoCodes.unshift(...PREFERRED_COUNTRIES.map((entry) => entry.code), "");
  const countryByIso = sorted.reduce(
    (map, country) => {
      map[country.isoCode] = country.name;
      return map;
    },
    {} as { [iso: string]: string },
  );

  const selectedCode = value ? value.alpha2 : DEFAULT_COUNTRY;

  const label = forCompany
    ? getMessage(`Company.${name}`)
    : getMessage(`Person.${name}`);
  return (
    <div>
      <DropdownField
        name={`${dataPath}${path}`}
        menuItems={isoCodes.map((code: string) => {
          return {
            value: code,
            children: countryByIso[code],
            disabled: !code,
          };
        })}
        selectedItemValue={selectedCode}
        label={label}
        onSelectCallback={onSelectCallback}
      />
    </div>
  );
}
